import React, {PropTypes, Component} from 'react';
import './style.css';

class App extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  // static defaultProps = {}
  // state = {}

  render() {
    return (
      <div className="stevie">
        {this.props.children}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/components/App.jsx